export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-teal-900 to-teal-800 text-white py-20 px-8 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" viewBox="0 0 1000 500">
          <path d="M0,250 Q250,200 500,250 T1000,250" stroke="currentColor" strokeWidth="1" fill="none" />
          <path d="M0,300 Q250,250 500,300 T1000,300" stroke="currentColor" strokeWidth="1" fill="none" />
        </svg>
      </div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-5 gap-12 mb-16">
          <div className="col-span-2 space-y-6">
            <h3 
              className="text-3xl font-black"
              style={{ fontFamily: "'Noto Serif KR', serif" }}
            >
              신공<span className="text-amber-400">.</span>
            </h3>
            
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="이메일 주소"
                className="flex-1 px-4 py-3 bg-white/10 border border-white/20 rounded-full text-white placeholder-white/60 focus:outline-none focus:border-white/40 text-sm"
              />
              <button className="w-12 h-12 flex items-center justify-center bg-amber-600 rounded-full hover:bg-amber-700 transition-colors cursor-pointer">
                <i className="ri-notification-line text-lg"></i>
              </button>
            </div>
            
            <p 
              className="text-4xl font-bold leading-tight"
              style={{ fontFamily: "'Noto Serif KR', serif" }}
            >
              영화의 미래를<br />
              함께 만들어갑니다
            </p>
          </div>
          
          <div className="space-y-4">
            <h4 className="text-sm font-bold uppercase tracking-wider mb-4">프로젝트</h4>
            <a href="#about" className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
              영화 소개
            </a>
            <a href="#synopsis" className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
              시놉시스
            </a>
            <a href="#casting" className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
              캐스팅
            </a>
            <a href="#reviews" className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
              후기
            </a>
          </div>
          
          <div className="space-y-4">
            <h4 className="text-sm font-bold uppercase tracking-wider mb-4">후원하기</h4>
            <a href="#funding" className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
              펀딩 목표
            </a>
            <a href="#rewards" className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
              리워드
            </a>
            <a href="#" className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
              FAQ
            </a>
          </div>
          
          <div className="space-y-4">
            <h4 className="text-sm font-bold uppercase tracking-wider mb-4">문의</h4>
            <a href="#location" className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
              오시는 길
            </a>
            <a href="mailto:kmiw6@naver.com" className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
              이메일
            </a>
            <a href="tel:010-2638-1129" className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
              전화
            </a>
            <a href="#" className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
              제휴 문의
            </a>
          </div>
        </div>
        
        <div className="border-t border-white/20 pt-8 flex items-center justify-between">
          <p className="text-sm text-white/70">
            © 2025 신공 제작위원회. All rights reserved.
          </p>
          
          <div className="flex gap-4">
            <a href="https://www.instagram.com/masteractors/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors cursor-pointer">
              <i className="ri-instagram-line"></i>
            </a>
            <a href="https://www.facebook.com/people/%EA%B3%A0%EB%AA%85%EC%9D%BC/100094778737947/?sk=about&locale=ko_KR" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors cursor-pointer">
              <i className="ri-facebook-fill"></i>
            </a>
            <a href="https://www.youtube.com/@kmiactor" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors cursor-pointer">
              <i className="ri-youtube-fill"></i>
            </a>
            <a href="#" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors cursor-pointer">
              <i className="ri-twitter-x-line"></i>
            </a>
          </div>
          
          <div className="flex gap-4 text-sm text-white/70">
            <a href="#" className="hover:text-white transition-colors cursor-pointer">개인정보처리방침</a>
            <span>|</span>
            <a href="#" className="hover:text-white transition-colors cursor-pointer">이용약관</a>
            <span>|</span>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Website Builder</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
